import script from "./app-toolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./app-toolbar.vue?vue&type=script&setup=true&lang=js"

import "./app-toolbar.vue?vue&type=style&index=0&id=0be35432&lang=css"

const __exports__ = script;

export default __exports__